import { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await axios.post('https://whats-app.360websitedemo.com/api/login', {
        email,
        password,
      });
      localStorage.setItem('token', response.data.token);
      setEmail('');
      setPassword('');
      setError('');
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="w-full max-w-4xl flex bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="w-1/2 bg-green-700 text-white p-8">
          <h1 className="text-2xl font-bold mb-4">WhatsApp Sender</h1>
          <p className="mb-6">Connect with your customers instantly</p>
          <div className="space-y-4">
            <p className="text-green-100">Secure messaging platform</p>
            <p className="text-green-100">Fast and reliable</p>
          </div>
        </div>
        <div className="w-1/2 p-8">
          <h2 className="text-xl font-semibold mb-6">Sign in to your account</h2>
          <p className="text-gray-600 mb-6">Enter your credentials to access your account</p>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="you@example.com"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
            >
              Sign in
            </button>
          </div>
          <p className="mt-4 text-center text-gray-600 text-sm">
            Don’t have an account?{' '}
            <Link to="/register" className="text-blue-600 hover:underline">Sign up</Link>
          </p>
          <p className="mt-2 text-center text-gray-600 text-sm">
            <Link to="/forgot-password" className="text-blue-600 hover:underline">Forgot Password?</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;